import { CloseIcon } from '@repo/icons';
import { Button } from '@repo/ui/button';
import { Dialog, DialogClose, DialogContent, DialogHeader, DialogPortal, DialogTitle } from '@repo/ui/dialog';
import { useTranslations } from 'next-intl';
import React from 'react';
import Deposit from '@/app/[locale]/(account)/account/deposit';
import { type QuickDepositProps } from '@/components/common/quick-deposit';
import { PAYMENT_TYPES } from '@/constants';

const QuickDepositModal = ({ open, handleOpen }: QuickDepositProps) => {
  const t = useTranslations(PAYMENT_TYPES.DEPOSITS);

  return (
    <Dialog
      open={open}
      onOpenChange={handleOpen}
    >
      <DialogPortal>
        <DialogContent
          portalOverlayClassName="z-[var(--z-quick-deposit-modal-overlay)]"
          className="z-[var(--z-quick-deposit-modal)] min-w-[900px] gap-0 rounded-lg"
        >
          <DialogHeader className="flex h-[45px] w-full flex-row items-center justify-between border-b border-[var(--surface-lighter-bg)] px-3">
            <DialogTitle>{t('qd-title')}</DialogTitle>
            <DialogClose asChild>
              <Button
                variant="blank"
                className="!bg-transparent !p-0"
              >
                <CloseIcon className="size-3" />
              </Button>
            </DialogClose>
          </DialogHeader>
          <div className="p-3 pt-0">
            <Deposit />
          </div>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
};

export default QuickDepositModal;
